// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nameChoice__wrapper__yy-Ga","input":"nameChoice__input__1JAvT","buttonBox":"nameChoice__buttonBox__2Q4n3","button":"nameChoice__button__3-WQg"};